import styles from "./product-page.module.scss";
import cl from "classnames";
import { observer } from "mobx-react-lite";
import { PageContainer } from "components";
import { useRootStore } from "mobx-stores/store-provider";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import {
  AttributeGroupDTO,
  AttributeGroupValueDTO,
  Button,
  ImagePortrait,
  RatingStars,
} from "@touche-lts/panel-ui/dist";
import { ImageGallery } from "components/general/image-gallery";
import { ReviewDTO } from "models/review";

const ProductPageComponent = () => {
  const defaultImageSrc =
      "https://st2.depositphotos.com/4403291/7418/v/600/depositphotos_74189661-stock-illustration-online-shop-log.jpg",
    { productId } = useParams<{ productId: string }>(),
    {
      storesPublic: {
        getProductById,
        singlePageStore,
        productInfo,
        changeSelectedAttribute,
        addToCartProduct,
        changeSelectedShipping,
        setSkuByDefault,
        selectedSKU,
        selectedSkuStock,
        relatedImages,
      },
      routingStore: { push },
    } = useRootStore(),
    userDetailsId = JSON.parse(localStorage.getItem("userDetails"))?.id,
    userRole = JSON.parse(localStorage.getItem("userDetails"))?.role?.name,
    isStoreAdmin = userRole === "STORE_ADMIN" || userRole === "SUPER_ADMIN",
    formRef = useRef<HTMLFormElement>(),
    handleSelectedValues = (): void => {
      addToCartProduct(userDetailsId, productCount);
    },
    handleBuyNow = (): void => {
      setBtnDisabled(true);
      addToCartProduct(userDetailsId, productCount, true);
    },
    getSelectedValue = (ev, index): void => {
      if (!attrIds.includes(ev.target.id)) {
        setAttrIds([...attrIds, ev.target.id]);
      }
      changeSelectedAttribute(ev.target.value, index);
      setProductCount(1);
    },
    countProductCount = (minusPlusCount: number): void => {
      const numberCount = productCount + minusPlusCount;
      if (!!numberCount) {
        setProductCount(numberCount);
      }
    },
    dropDownIndicatorStyle = {
      dropdownIndicator: (base) => ({
        ...base,
        color: "white",
        marginRight: 10,
      }),
    },
    [productCount, setProductCount] = useState(1),
    [attrIds, setAttrIds] = useState([]),
    [btnDisabled, setBtnDisabled] = useState(false),
    validateQty = (): boolean => {
      if (
        productInfo?.attGroups.length !== attrIds.length ||
        (productInfo?.productSkus.length === 1
          ? productInfo?.mainSku?.stock
          : selectedSkuStock) <= 1
      ) {
        return true;
      }
      return false;
    };

  const isNotValidQty = validateQty();
  const selectedSkuPrice = productInfo?.productSkus?.find(
    (sku) => sku.sku === selectedSKU,
  )?.price;

  useEffect(() => {
    getProductById(productId);
    setProductCount(1);
    setAttrIds([]);
    formRef.current.reset();
  }, [getProductById, productId]);

  useEffect(() => {
    setSkuByDefault();
  }, [productInfo?.attGroups, setSkuByDefault]);

  return (
    <PageContainer
      className={cl(styles.scrollable)}
      style={{ maxHeight: "fit-content" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            {relatedImages?.length > 0 && (
              <div className={styles.pictureGalleryContainer}>
                <ImageGallery images={relatedImages} />
              </div>
            )}
            {/* {!selectedSliderImages?.length && productInfo?.images && !!productInfo?.images.length && (
                    <div className={styles.pictureGalleryContainer}>
                        <ImageGallery
                            images={productInfo?.images}
                        />
                    </div>
                )}
                {!!selectedSliderImages?.length &&
                    <ImageGallery
                        images={selectedSliderImages}
                    />
                } */}
          </div>
          <div className="col-lg-8">
            <div className={styles.infoContainer}>
              <div className={styles.testInfo}>
                <h2>{productInfo?.name}</h2>
                <span>by {productInfo?.manufacturer}</span>
                <RatingStars
                  rating={productInfo?.rating}
                  reviewsCnt={productInfo?.reviewsCnt}
                />
                <p>{productInfo?.info}</p>
              </div>
              <div className={styles.quantityPrice}>
                <h1>
                  US ${selectedSkuPrice ?? productInfo?.mainSku?.price}{" "}
                  {/** TODO-A Currency to be correctly fetch */}
                </h1>
                <div className={styles.quantityCount}>
                  <p className={styles.quantityText}>Quantity</p>
                  <span
                    className={
                      isNotValidQty || productCount === 1
                        ? styles.disableBehavior
                        : ""
                    }
                    onClick={() => countProductCount(-1)}
                  >
                    -
                  </span>
                  <p className={styles.quantity}>{productCount}</p>
                  <span
                    className={
                      isNotValidQty || productCount === selectedSkuStock
                        ? styles.disableBehavior
                        : ""
                    }
                    onClick={() => countProductCount(1)}
                  >
                    +
                  </span>
                </div>
              </div>
              {productCount === selectedSkuStock && (
                <div className={styles.quantityError}>
                  Maximum quantity available
                </div>
              )}
              {selectedSkuStock === 0 && (
                <div className={styles.quantityError}>Out of stock</div>
              )}

              <div className={styles.productAttributes}>
                <form ref={formRef}>
                  {productInfo?.attGroups?.map(
                    (attrGroup: AttributeGroupDTO, index) => {
                      return (
                        <div className={styles.productAttribute}>
                          <p>{attrGroup?.name}</p>
                          <select
                            id={String(attrGroup?.id)}
                            onChange={(ev) => getSelectedValue(ev, index)}
                            className={cl(
                              styles.selectShipping,
                              dropDownIndicatorStyle,
                            )}
                          >
                            {attrGroup?.values.map(
                              (attr: AttributeGroupValueDTO) => {
                                return (
                                  <>
                                    <option defaultValue={""} hidden>
                                      {"--"}
                                    </option>
                                    <option value={attr?.id}>
                                      {attr?.name}
                                    </option>
                                  </>
                                );
                              },
                            )}
                          </select>
                        </div>
                      );
                    },
                  )}
                </form>
              </div>
              {/* {!selectedSKU && (
                            <div className={styles.skuProduct}>SKU: {productInfo?.mainSku?.sku}</div>
                        )} */}
              {selectedSKU &&
                productInfo.attGroups.length === attrIds.length && (
                  <div className={styles.skuProduct}>SKU: {selectedSKU}</div>
                )}
              <hr className={styles.separateEndLine} />
              {productInfo?.shippings && (
                <div className={styles.productAttributes}>
                  <div className={styles.productAttribute}>
                    <p>Shippings</p>
                    <select
                      onChange={(ev) => changeSelectedShipping(ev)}
                      className={cl(
                        styles.selectShipping,
                        dropDownIndicatorStyle,
                      )}
                    >
                      {productInfo?.shippings.map((shipping, indexShipping) => {
                        return (
                          <>
                            <option value={shipping?.id}>
                              {shipping?.name} - {shipping?.currency}{" "}
                              {shipping?.price}
                            </option>
                          </>
                        );
                      })}
                    </select>
                  </div>
                </div>
              )}
              {!isStoreAdmin &&
                productInfo?.attGroups.length === attrIds.length &&
                selectedSkuStock !== 0 && (
                  <div className={styles.addToCartBuyNow}>
                    <Button
                      preset="secondary"
                      colorPreset="dark"
                      onClick={() => handleSelectedValues()}
                    >
                      Add to Cart
                    </Button>
                    <Button
                      preset="primary"
                      onClick={handleBuyNow}
                      disabled={btnDisabled}
                    >
                      Buy now
                    </Button>
                  </div>
                )}
            </div>
          </div>
        </div>
        <div className={styles.moreFromStoreName}>
          <p className={styles.moreFromStore}>
            More items from {productInfo?.store?.name}
          </p>
          <div className={cl(styles.storesContainer)}>
            {singlePageStore &&
              singlePageStore.content.slice(0, 5).map((product) => {
                // TODO-A To add model type
                return (
                  <div
                    onClick={() => push(`/product/${product?.id}`)}
                    className={styles.productInfo}
                  >
                    <div className={styles.productInfoDetails}>
                      <ImagePortrait
                        width={176}
                        height={176}
                        src={
                          !!product?.image
                            ? product?.image?.url
                            : defaultImageSrc
                        }
                      />
                      <div className={styles.productInfoDetailsText}>
                        <h2>{product.name}</h2>
                        <RatingStars
                          rating={product?.rating}
                          reviewsCnt={product?.reviewsCnt}
                        />
                        <small>Add to cart</small>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
          <p
            onClick={() => push(`/stores/${productInfo?.storeId}`)}
            className={styles.goToStore}
          >
            Go to store
          </p>
          <hr className={styles.separateEndLine} />
          <p className={styles.moreFromStore}>
            Customer reviews {productInfo?.store?.name} (
            {productInfo?.reviews?.length})
          </p>
          <div className={styles.reviewsContainer}>
            {productInfo?.reviews &&
              productInfo?.reviews.map((review: ReviewDTO) => {
                return (
                  <div className="d-flex px-1">
                    <div className={styles.reviewsBox}>
                      <RatingStars rating={review?.rating} />
                      <p>{review.userName}</p>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

const ProductPage = observer(ProductPageComponent);
export { ProductPage };
